import { Col, Row } from "antd";
import { ReactNode } from "react";

interface PriceRowProps {
  label: string;
  value: string | number;
  unit?: string;
  icon?: ReactNode;
  labelClassName?: string;
  valueClassName?: string;
  isNegative?: boolean;
  backgroundColor?: string;
  labelSpan?: number;
  valueSpan?: number;
  simpleLayout?: boolean;
}

export const PriceRow = ({
  label,
  value,
  unit = "บาท",
  icon,
  labelClassName = "py-2 px-8 text-sm",
  valueClassName = "text-end py-2 px-8 text-sm",
  isNegative = false,
  backgroundColor,
  labelSpan = 12,
  valueSpan = 12,
  simpleLayout = false,
}: PriceRowProps) => {
  const formattedValue = typeof value === "number" ? value.toLocaleString() : value;
  const displayValue = isNegative ? `- ${formattedValue}` : formattedValue;

  const baseValueClass = isNegative
    ? `${valueClassName} text-danger-500`
    : valueClassName;

  return (
    <>
      <Col span={labelSpan} className={labelClassName} style={backgroundColor ? { backgroundColor } : undefined}>
        {label}
      </Col>
      <Col span={valueSpan} className={baseValueClass} style={backgroundColor ? { backgroundColor } : undefined}>
        {simpleLayout ? (
          <>{icon}{displayValue} {!icon && unit}</>
        ) : (
          <Row>
            <Col span={unit === "" ? 24 : 18}>{displayValue}</Col>
            {unit !== "" && (
              <Col span={6} className="flex justify-center">
                {icon || unit}
              </Col>
            )}
          </Row>
        )}
      </Col>
    </>
  );
};